export const PAYMONGO_CHANNELS = [
  "card",
  "gcash",
  "paymaya",
  "grab_pay",
  "dob",
  "billease",
  "qrph",
  ""
] as const;
export type PaymongoChannel = (typeof PAYMONGO_CHANNELS)[number];

export const PAYMONGO_CHANNEL_LABEL: Record<PaymongoChannel, string> = {
  card: "Credit / debit card",
  gcash: "GCash",
  paymaya: "Maya",
  grab_pay: "GrabPay",
  dob: "Online banking",
  billease: "BillEase",
  qrph: "QR Ph",
  "": "PayMongo",
};

// dob bank_code -> human bank name. Live and PayMongo-sandbox codes both map
// so order metadata gets a readable label in every environment.
export const DOB_BANK_LABEL: Record<string, string> = {
  bpi: "BPI",
  ubp: "UnionBank",
  test_bank_one: "BPI",
  test_bank_two: "UnionBank",
};

export const PAYMONGO_CONVENIENCE_FEE = [
  { name: "card", isLocal: true, rate: 0.023, flatRate: 0 },
  { name: "card", isLocal: false, rate: 0.033, flatRate: 0 },
  { name: "gcash", rate: 0.019, flatRate: 0 },
  { name: "paymaya", rate: 0.019, flatRate: 0 },
  { name: "grab_pay", rate: 0.019, flatRate: 0 },
  { name: "dob", rate: 0, flatRate: 15 },
] as const;

// PayMongo convenience fee on (subtotal + shipping). Single source of truth for
// both the checkout display (useFetchConvenienceFee) and what we persist/charge
// at place-order. Mirrors the original display logic exactly: rate-based
// channels charge rate × base; everything else (dob's flat rate, dragonpay,
// unknown channels) is 0.
export function computeConvenienceFee(
  channel: string,
  base: number,
  countryCode: string,
): number {
  const intlCard = channel === "card" && !!countryCode && countryCode !== "ph";
  const item = PAYMONGO_CONVENIENCE_FEE.find((entry) => {
    if (entry.name !== channel) return false;
    if (entry.name === "card") return entry.isLocal === !intlCard;
    return true;
  });
  return item?.rate ? item.rate * base : 0;
}

export type PaymongoBilling = {
  name: string;
  email: string;
  phone?: string;
  address: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
  };
};
